export function PageHeader({ title, subtitle, actions, eyebrow }) {
    return (
        <div className="flex flex-col xl:flex-row xl:items-end xl:justify-between gap-4 xl:gap-6 mb-8 border-b border-zinc-200 pb-6">
            <div className="min-w-0 flex-1">
                {eyebrow && (
                    <div className="overline mb-2" data-testid="page-eyebrow">
                        {eyebrow}
                    </div>
                )}
                <h1
                    className="text-3xl md:text-4xl font-display font-bold tracking-tight text-zinc-900"
                    data-testid="page-title"
                >
                    {title}
                </h1>
                {subtitle && (
                    <p className="text-zinc-500 mt-2 text-sm max-w-2xl">
                        {subtitle}
                    </p>
                )}
            </div>
            {actions && (
                <div className="flex flex-wrap items-center gap-2 xl:shrink-0">
                    {actions}
                </div>
            )}
        </div>
    );
}

export function StatCard({ label, value, hint, accent, testId }) {
    return (
        <div
            className="bg-white border border-zinc-200 p-5 hover:border-zinc-300 transition-colors duration-200"
            data-testid={testId}
        >
            <div className="overline">{label}</div>
            <div
                className={`mt-2 font-display text-3xl font-bold tabular-nums ${accent ? "wl-accent-text" : "text-zinc-900"}`}
            >
                {value}
            </div>
            {hint && (
                <div className="text-xs text-zinc-500 mt-1.5">{hint}</div>
            )}
        </div>
    );
}

export function Section({ title, action, children, testId }) {
    return (
        <section className="mb-10" data-testid={testId}>
            <div className="flex items-center justify-between mb-4">
                <h2 className="font-display text-lg text-zinc-800 font-semibold">
                    {title}
                </h2>
                {action}
            </div>
            {children}
        </section>
    );
}
